import React from 'react';
import { IconType } from 'react-icons';
import './toggleswitch.css';
import './roundbutton.css';

type Props = {
    className?   : string;
    description? : boolean
    disabled?    : boolean;
    name?        : string;
    icon         : IconType;
    size?        : number;

    onClick : () => void;
};

export class RoundButton extends React.Component<Props> 
{
    displayDescription() : boolean
    {
        if (this.props.name === undefined) 
            return false;
        if (this.props.description === undefined) 
            return true;
        return this.props.description;
    }

    getClasses() : string
    {
        let classes = "";
        if (this.props.className === undefined) {
            classes = "roundbtn-icon";
        }
        else {
            classes = this.props.className;
        }

        if (this.props.disabled) {
            if (classes.length > 0) {
                classes += " ";
            }
            classes += "disabled";
        }
        return classes;
    }

    onClick()
    {
        if (this.props.onClick && (this.props.disabled === undefined || !this.props.disabled)) {
            this.props.onClick();
        }
    }

    render() {
        const size = this.props.size ?? 24;

        const divStyle = {
            borderRadius: (size/2+5) + 'pt',
            fontSize:  size + 'pt',
            height:    (size+8) + 'pt',
        } as React.CSSProperties;

        return (
            <div className="roundbtn">
                <div
                    className={this.getClasses()}
                    style={divStyle}
                    title={this.props.name}
                    onClick={() => this.onClick() } >
                    { React.createElement(this.props.icon as React.ComponentType) }
                </div>
                { this.displayDescription() && (
                    <div className="roundbtn-desc">{this.props.name}</div>)
                }
            </div>
        );
    }
}

